import axios from "axios";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

export interface ExternalNewsItem {
    id?: string;
    image: string;
    sourceName: string;
    title: string;
    url: string;
    publishDate?: string;
    createdTimestamp?: number;
}

const ExternalNewsAPI = {
    getAllExternalNews: async (): Promise<ExternalNewsItem[]> => {
        try {
            const { data: response } = await axios.get("/external-news");
            return response;
        } catch (error) {
            console.error("Error fetching external news:", error);
            return [];
        }
    },

    getExternalNewsById: async (id: string): Promise<ExternalNewsItem | null> => {
        try {
            const { data: response } = await axios.get(`/external-news/${id}`);
            return response;
        } catch (error) {
            console.error("Error fetching external news by id:", error);
            return null;
        }
    },

    createExternalNews: async (data: ExternalNewsItem): Promise<ExternalNewsItem | null> => {
        try {
            const { data: response } = await axios.post("/external-news", { ...data });
            AlertsService.showSuccess("Внешняя новость добавлена");
            return response;
        } catch (error) {
            AlertsService.showError("Ошибка при добавлении внешней новости");
            return null;
        }
    },

    updateExternalNews: async (data: ExternalNewsItem): Promise<ExternalNewsItem | null> => {
        try {
            const { data: response } = await axios.put("/external-news", { ...data });
            AlertsService.showSuccess("Внешняя новость обновлена");
            return response;
        } catch (error) {
            AlertsService.showError("Ошибка при обновлении внешней новости");
            return null;
        }
    },

    deleteExternalNews: async (id: string): Promise<boolean> => {
        try {
            await axios.delete(`/external-news/${id}`);
            AlertsService.showSuccess("Внешняя новость удалена");
            return true;
        } catch (error) {
            AlertsService.showError("Ошибка при удалении внешней новости");
            return false;
        }
    },
};

export default ExternalNewsAPI;
